import { IDataTagList } from 'source/NFR.types';

const DataTagList: React.FC<IDataTagList> = ({ list }) => {
  return (
    <ul className="data-tag-list">
      {list?.map((tag, idx) => (
        <li key={'data-tag-' + idx} className="data-tag-list--item">
          {tag}
        </li>
      ))}
    </ul>
  );
};

DataTagList.displayName = 'DataTagList';

export default DataTagList;
